// DS: i11.20
import React from 'react';
import IconWrap from '../../IconWrap';
const RemoveBackground = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.885 1.995a.837.837 0 0 1 0 1.183L3.178 5.885a.837.837 0 1 1-1.183-1.183l2.707-2.707a.837.837 0 0 1 1.183 0m4.06 0a.837.837 0 0 1 0 1.183L3.178 9.945a.837.837 0 0 1-1.183-1.183l6.767-6.767a.837.837 0 0 1 1.183 0m4.06 1.183a.837.837 0 0 0-1.183-1.183L1.995 12.822a.837.837 0 0 0 1.183 1.183zm0 2.877a.837.837 0 0 1 0 1.183L7.24 14.005a.837.837 0 0 1-1.183-1.183l6.766-6.767a.837.837 0 0 1 1.184 0Zm-.001 5.243a.837.837 0 0 0-1.183-1.183l-2.707 2.707a.837.837 0 0 0 1.183 1.183z",
        clipRule: "evenodd"
    })));
};
RemoveBackground.displayName = 'RemoveBackground';
export default RemoveBackground;

//# sourceMappingURL=RemoveBackground.js.map